'use strict';
var parent = require('../../actual/array/from');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/full/array/from.js
// module id = 1237
// module chunks = 0